import { render, staticRenderFns } from "./SupplierOrRepairFactoryDialog.vue?vue&type=template&id=389a178c&scoped=true"
import script from "./SupplierOrRepairFactoryDialog.vue?vue&type=script&lang=ts"
export * from "./SupplierOrRepairFactoryDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389a178c",
  null
  
)

export default component.exports